export let bannerDetailsES= [
    { "text": 'Di HOLA al Futuro del Entretenimiento Digital',
        "image": './img/slider/default-banner.jpg',
        "shortText": 'Di HOLA al Futuro del Entretenimiento Digital',
        "video":""},
    { "text": '',
        "image": './img/slider/esmobiotv-slide-1.jpeg',
        "shortText": 'Zoomin TV',
     "video" : {
        "duration": "Watch Now",
        "id": 1,
        "name": "Pablo Escobar, el patron del mal - Episode - 1",
        "year": 2012,
        "preview": "./img/esmobiotv/tv-series/Pablo-Escobar-el-patron-del-mal.jpeg",
        "desc": "PABLO ESCOBAR: EL PATRON DEL MAL, PARTE 1-3 Based on the best seller \" La Parabola de Pablo \" by journalist and ex Major of Medellin, Alonso Salazar, the series from Juana Uribe and Camilo Cano is based on real life events and is backed up by an impressive journalist documentation that makes it the most ambitious TV series from Colombia. In the series we are presented with a provocative and realist look at the life of one of the most famous criminals of the XX Century: Pablo Escobar. Considered by some a hero and by others the most violent of \"Capos\" ever. ",
        "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Spanish/Pablo+Escobar+Capitulo/Pablo+Escobar+Capitulo+1.mp4",
        "subCategory": [
            {
                "duration": "Watch Now",
                "id": 28,
                "name": "Pablo Escobar, el patron del mal - Episode - 2",
                "year": 2012,
                "preview": "./img/esmobiotv/tv-series/Pablo-Escobar-el-patron-del-mal.jpeg",
                "desc": "PABLO ESCOBAR: EL PATRON DEL MAL, PARTE 1-3 Based on the best seller \" La Parabola de Pablo \" by journalist and ex Major of Medellin, Alonso Salazar, the series from Juana Uribe and Camilo Cano is based on real life events and is backed up by an impressive journalist documentation that makes it the most ambitious TV series from Colombia. In the series we are presented with a provocative and realist look at the life of one of the most famous criminals of the XX Century: Pablo Escobar. Considered by some a hero and by others the most violent of \"Capos\" ever. ",
                "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Spanish/Pablo+Escobar+Capitulo/Pablo+Escobar+Capitulo+2.mp4",
                "subCategory": []
            },
        ],
    }
    },
    { "text": '',
        "image": './img/slider/esmobiotv-slide-2.jpeg',
        "shortText": 'Fitness TV',
        "video":{
            "duration": "Watch Now",
            "id": 10,
            "name": "La piel que habito",
            "year": 2011,
            "preview": "./img/esmobiotv/movies/The-Skin-I-Live-In.jpeg",
            "desc": "Robert Ledgard (Antonio Baneras) es un eminente cirujano plástico que realiza sus experimentos en su clínica privada, El Cigarral. Desde que su mujer y su hija murieran, vive obsesionado con la creación de un nuevo tipo de piel, al que ha denominado G.A.L. La comunidad científica no permite esos experimentos, pero él, de forma clandestina, ha seguido realizándolos por su cuenta gracias a una cobaya, una joven, Vera (Elena Anaya, 'Habitación en Roma') a la que mantiene retenida y que se ha convertido en el centro de su vida. Pero Vera oculta un secreto y quiere venganza por todo lo que el doctor Legrand ha hecho con ella. Los dos viven encerrados en la mansión del cirujano junto a la servil Marilia (Marisa Paredes, 'La flor de mi secreto'), que es en realidad la madre de Robert.  El equilibrio del trío protagonista se verá alterado cuando una tarde de carnaval se presente en la casa otro de los hijos de Marilia, Zeca (Roberto Álamo, 'Dispongo de barcos'), disfrazado de tigre, arrollando por donde pase y creando confusión en el delicado microclima de relaciones que se ha establecido. A partir de ese momento, nada volverá a ser lo mismo para ninguno de ellos. Marilia, Robert y Vera rememorarán su pasado, cada uno desde su punto de vista. Un pasado que vuelve para tomarse su revancha.",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Spanish/The+Skin+I+Live+In/The+Skin+I+Live+In.mp4",
            "subCategory":[]

        },
    },
    { "text": '',
        "image": './img/slider/esmobiotv-slide-3.jpeg',
        "shortText": 'Mobio Yoga',
        "video":{
            "duration": "Watch Now",
            "id": 20,
            "name": "Pasión por el flamenco",
            "year": 2015,
            "preview": "./img/esmobiotv/documentaries/Pasión-por-el-flamenco.jpeg",
            "desc": "A look at the history and traditions of flamenco music and dance.",
            "videoUrl": "",
            "subCategory":[]

        },
    },
];

export let bannerDetailsESMobile =[
    { "text": 'Di HOLA al Futuro del Entretenimiento Digital',
        "image": './img/slider/mobile/mobile-default-banner.jpeg',
        "shortText": 'Di HOLA al Futuro del Entretenimiento Digital',
        "video":""},
    { "text": '',
        "image": './img/slider/mobile/mobile-esmobiotv-slide-1.jpeg',
        "shortText": 'Zoomin TV',
        "video" : {
            "duration": "Watch Now",
            "id": 1,
            "name": "Pablo Escobar, el patron del mal - Episode - 1",
            "year": 2012,
            "preview": "./img/esmobiotv/tv-series/Pablo-Escobar-el-patron-del-mal.jpeg",
            "desc": "PABLO ESCOBAR: EL PATRON DEL MAL, PARTE 1-3 Based on the best seller \" La Parabola de Pablo \" by journalist and ex Major of Medellin, Alonso Salazar, the series from Juana Uribe and Camilo Cano is based on real life events and is backed up by an impressive journalist documentation that makes it the most ambitious TV series from Colombia. In the series we are presented with a provocative and realist look at the life of one of the most famous criminals of the XX Century: Pablo Escobar. Considered by some a hero and by others the most violent of \"Capos\" ever. ",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Spanish/Pablo+Escobar+Capitulo/Pablo+Escobar+Capitulo+1.mp4",
            "subCategory": [
                {
                    "duration": "Watch Now",
                    "id": 28,
                    "name": "Pablo Escobar, el patron del mal - Episode - 2",
                    "year": 2012,
                    "preview": "./img/esmobiotv/tv-series/Pablo-Escobar-el-patron-del-mal.jpeg",
                    "desc": "PABLO ESCOBAR: EL PATRON DEL MAL, PARTE 1-3 Based on the best seller \" La Parabola de Pablo \" by journalist and ex Major of Medellin, Alonso Salazar, the series from Juana Uribe and Camilo Cano is based on real life events and is backed up by an impressive journalist documentation that makes it the most ambitious TV series from Colombia. In the series we are presented with a provocative and realist look at the life of one of the most famous criminals of the XX Century: Pablo Escobar. Considered by some a hero and by others the most violent of \"Capos\" ever. ",
                    "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Spanish/Pablo+Escobar+Capitulo/Pablo+Escobar+Capitulo+2.mp4",
                    "subCategory": []
                },
            ],
        }
    },
    { "text": '',
        "image": './img/slider/mobile/mobile-esmobiotv-slide-2.jpeg',
        "shortText": 'Fitness TV',
        "video":{
            "duration": "Watch Now",
            "id": 10,
            "name": "La piel que habito",
            "year": 2011,
            "preview": "./img/esmobiotv/movies/The-Skin-I-Live-In.jpeg",
            "desc": "Robert Ledgard (Antonio Baneras) es un eminente cirujano plástico que realiza sus experimentos en su clínica privada, El Cigarral. Desde que su mujer y su hija murieran, vive obsesionado con la creación de un nuevo tipo de piel, al que ha denominado G.A.L. La comunidad científica no permite esos experimentos, pero él, de forma clandestina, ha seguido realizándolos por su cuenta gracias a una cobaya, una joven, Vera (Elena Anaya, 'Habitación en Roma') a la que mantiene retenida y que se ha convertido en el centro de su vida. Pero Vera oculta un secreto y quiere venganza por todo lo que el doctor Legrand ha hecho con ella. Los dos viven encerrados en la mansión del cirujano junto a la servil Marilia (Marisa Paredes, 'La flor de mi secreto'), que es en realidad la madre de Robert.  El equilibrio del trío protagonista se verá alterado cuando una tarde de carnaval se presente en la casa otro de los hijos de Marilia, Zeca (Roberto Álamo, 'Dispongo de barcos'), disfrazado de tigre, arrollando por donde pase y creando confusión en el delicado microclima de relaciones que se ha establecido. A partir de ese momento, nada volverá a ser lo mismo para ninguno de ellos. Marilia, Robert y Vera rememorarán su pasado, cada uno desde su punto de vista. Un pasado que vuelve para tomarse su revancha.",
            "videoUrl": "https://s3-eu-west-1.amazonaws.com/mobiotv-contents/Spanish/The+Skin+I+Live+In/The+Skin+I+Live+In.mp4",
            "subCategory":[]

        },
    },
    { "text": '',
        "image": './img/slider/mobile/mobile-esmobiotv-slide-3.jpeg',
        "shortText": 'Mobio Yoga',
        "video":{
            "duration": "Watch Now",
            "id": 20,
            "name": "Pasión por el flamenco",
            "year": 2015,
            "preview": "./img/esmobiotv/documentaries/Pasión-por-el-flamenco.jpeg",
            "desc": "A look at the history and traditions of flamenco music and dance.",
            "videoUrl": "",
            "subCategory":[]

        },
    },
];


// WEBPACK FOOTER //
// ./src/constants/bannerDetailsES.js